import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "設施即時人流", -1)
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "健身房", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "游泳池", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ／ ")
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ScrollWrap = _resolveComponent("ScrollWrap")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.basic, 'card'])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_Button, {
          btnName: "Close",
          btyType: "close",
          title: "關閉",
          class: "close",
          onClick: _cache[0] || (_cache[0] = () => _ctx.setModal(_ctx.ModalType.None))
        })
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$style.content, _ctx.$style.crowd])
      }, [
        _createElementVNode("ul", {
          class: _normalizeClass(_ctx.$style.firstRow)
        }, [
          _createElementVNode("li", null, [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(_ctx.$style.citySelector),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cntCity) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distList, (city) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: city.cityId,
                    value: city.cityId
                  }, _toDisplayString(city.cityName), 9, _hoisted_3))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.cntCity]
              ])
            ]),
            _hoisted_4,
            _hoisted_5
          ])
        ], 2),
        _createVNode(_component_ScrollWrap, {
          hasLoading: !Object.keys(_ctx.data).length
        }, {
          default: _withCtx(() => [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.venueList, (v) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: v }, [
                  (v.cityId === _ctx.cntCity)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                        _createElementVNode("div", null, _toDisplayString(v.venueName), 1),
                        (_ctx.data[v.venueId])
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.Placetype, (i) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                (_ctx.data[v.venueId][i].capacity)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass([
                        _ctx.$style.tag,
                        `level_${_ctx.levelColor(_ctx.data[v.venueId][i])}`,
                      ])
                                    }, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.data[v.venueId][i].count), 1),
                                      _hoisted_7,
                                      _createElementVNode("span", null, _toDisplayString(_ctx.data[v.venueId][i].capacity), 1)
                                    ], 2))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass([_ctx.$style.tag])
                                      }, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.data[v.venueId][i].count), 1)
                                      ], 2)
                                    ]))
                              ], 64))
                            }), 128))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass([_ctx.$style.noData, 'disable'])
                            }, "尚未提供", 2))
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["hasLoading"])
      ], 2)
    ], 2)
  ]))
}